import React, { useEffect, useState } from 'react'
import { AutoComplete } from 'primereact/autocomplete'
import { fetchData } from '../../helpers/fetchData'

const AccountAutoComplete = ({ lang, t, onAccountSelect, value, className }) => {
    const [inputValue, setInputValue] = useState(value || '')
    const [suggestions, setSuggestions] = useState([])
    const [searched, setSearched] = useState(false)

    useEffect(() => {
        setInputValue(value || '')
    }, [value])

    const fetchAccounts = async (query) => {
        try {
            setSearched(true)
            const payload = { query }
            const res = await fetchData('POST', 'searchAccounts', payload)
            const data = res?.data

            if (data && typeof data === 'object' && Object.keys(data).length > 0) {
                const options = Object.entries(data).map(([id, account]) => ({
                    ...account,
                    label: lang === 'ar'
                        ? `${account?.name_ar || ''} ${account?.code || ''}`
                        : `${account?.name_en || ''} ${account?.code || ''}`
                }))
                setSuggestions(options)
            } else {
                setSuggestions([{ label: t('No account found'), code: 'no_result', disabled: true }])
            }
        } catch (error) {
            console.error('Error fetching accounts:', error)
            setSuggestions([])
        }
    }

    const handleComplete = (event) => {
        if (event.query && event.query.trim().length > 0) {
            fetchAccounts(event.query)
        } else {
            setSuggestions([])
            setSearched(false)
        }
    }

    const handleSelect = (e) => {
        if (e.value && typeof e.value === 'object') {
            if (e.value.disabled) return // Prevent selection of "No account found"
            onAccountSelect(e.value)
            setInputValue(e.value.code)
        }
    }

    return (
        <AutoComplete
            value={inputValue}
            suggestions={suggestions}
            completeMethod={handleComplete}
            onChange={(e) => {
                if (typeof e.value === 'object' && e.value.disabled) return
                // If the user clears the input or types, just update the value
                // We handle object updates in onSelect
                const val = typeof e.value === 'object' ? e.value.code : e.value
                setInputValue(val)
                if (!val) {
                    setSuggestions([])
                    setSearched(false)
                }
            }}
            optionDisabled="disabled"
            onSelect={handleSelect}
            field="code"
            itemTemplate={(item) => (
                <div className={item.disabled ? 'text-gray-500 text-center italic p-1 pointer-events-none cursor-default' : ''}>
                    {item.label}
                </div>
            )}
            placeholder={t('Search by account code or name')}
            className={`w-full ${className || ''}`}
            pt={{
                input: {
                    root: {
                        className: 'w-full h-[30px] px-2 border border-gray-300 rounded-md hover:border-primary focus:border-primary !outline-none !shadow-none flex items-center'
                    }
                },
            }}
        />
    )
}

export default AccountAutoComplete
